import React from 'react'
import Progress from '../../components/Progress'
export default () => (
  <Progress />
)